<template lang="pug">
  v-btn( small icon @click='aprobar({id, aprobado})')
    v-icon( small :color='aprobado ? "primary" : "secondary" ') {{aprobado ? 'far fa-check-square' : 'far fa-square'}}
</template>
<script>
import { mapActions } from 'vuex'
export default {
  methods: {
    aprobar(id){
      if (this.tipo=='orden_de_compra') this.aprobar_item_orden_de_compra(id)
      if (this.tipo=='requerimiento') this.aprobar_item_requerimiento(id)
    },
    ...mapActions({
      aprobar_item_requerimiento: 'Requerimientos/aprobar_item',
      aprobar_item_orden_de_compra: 'Ordenes_de_compra/aprobar_item' 
    })
  },
  props: {
    tipo: String,
    id: String,
    aprobado: Boolean,
  },
}
</script>